import { IntlTFunc } from 'next-intl';

import { OrderFragment, OrderItem, ProductFragment } from '@/fo/api/magento';

import { MappedProduct } from '../types';

import { utilMapProductData } from './utilMapProductData';

export const utilMapOrderProductData = (
  orderItem: NonNullable<OrderFragment['items']>[0] | OrderItem,
  t: IntlTFunc
): MappedProduct | null => {
  if (!orderItem?.product) {
    return null;
  }

  const product = orderItem.product as ProductFragment;
  const mappedProduct = utilMapProductData(product, t);

  return {
    ...mappedProduct,
    quantity: orderItem.quantity_ordered ?? 0,
    mindbox_earned_bonus_amount: orderItem.mindbox_earned_bonus_amount ?? 0
  };
};
